<template>
  <div style="width:100%;padding-top: 60px">
    <div style="position: fixed;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="show" v-if="inputForm.isDoTask">
          办理
        </van-button>
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="close">返回</van-button>
      </div>

      <div class="doTask" v-if="isshow">
        <div>
          <van-field name="radio" label="审批意见">
            <template #input>
              <van-radio-group v-model="auditForm.status" direction="horizontal">
                <van-radio name="同意">同意</van-radio>
                <van-radio name="不同意">不同意</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </div>
        <div>
          <van-cell-group>
            <van-field v-model="auditForm.message" rows="2" autosize label="审批说明" type="textarea"
              placeholder="请输入审批说明" />
          </van-cell-group>
        </div>
        <div style="text-align:center">
          <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="submitTask()">提交</van-button>
        </div>
      </div>
    </div>
    <van-collapse v-model="activeNames">
      <van-collapse-item title="基本信息" name="1">
        <van-field v-model="inputForm.projectName" label="物业项目名" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.customerName" label="维保单位" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.principalName" label="维保联系人" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.mobile" label="联系电话" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"/>

        <van-field v-model="inputForm.serviceStartDate" label="合同服务期（起）" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.serviceEndDate" label="合同服务期（止）" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.maintainFee" label="维保费用(元/年)" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.promise" label="特殊约定" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"/>

        <van-row gutter="20" style="margin-top: 5%;">
          <van-image width="100" height="100" @click="preview(inputForm.license)" :src="inputForm.license" default="2" style="margin-left: 10%;" />
          <van-image width="100" height="100" @click="preview(inputForm.certificate)" :src="inputForm.certificate" default="2" style="margin-left: 20%;" />

          <van-row type="flex">
            <van-col style="margin-left: 15%;">营业执照</van-col>
            <van-col style="margin-left: 33%;">资质证书</van-col>
          </van-row>
        </van-row>
        <div style="padding-left: 16px;" v-show="inputForm.attachList.length > 0">
          <p>附件</p>
          <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.attachList" :key="index" @click="$viewAttach(file)">{{file.name}}</p>
        </div>
<!--        <div style="padding-left: 16px;" v-show="inputForm.attachList.length > 0">-->
<!--          <p>附件</p>-->
<!--          <a style="display: block; color: #4caedc" v-for="(file,index) in inputForm.attachList" :key="index" :href="file.url">{{file.name}}</a>-->
<!--        </div>-->
      </van-collapse-item>
      <van-collapse-item title=" 关联设备：" name="2">
        <b-table class="bgc-dark" small head-variant="dark" responsive bordered
                 :items="items" :fields="fields">
          <template v-slot:head()="scope">
            <div class="text-nowrap" :style="{textAlign:'center'}">
              {{ scope.label }}
            </div>
          </template>

          <template v-slot:table-colgroup="scope">
            <col
                v-for="field in scope.fields"
                :key="field.key"
                :style="{ width: '100px' }"
            >
          </template>
        </b-table>
<!--        <table>-->
<!--          <thead>-->
<!--            <tr>-->
<!--              <td style="width: 20%;">管理编码</td>-->
<!--&lt;!&ndash;              <td style="width: 20%;">设备编码</td>&ndash;&gt;-->
<!--              <td style="width: 20%;">设备名称</td>-->
<!--              <td style="width: 20%;">设备类型</td>-->
<!--              <td style="width: 20%;">运行状态</td>-->
<!--            </tr>-->
<!--          </thead>-->
<!--          <tbody>-->
<!--            <tr v-for="data in inputForm.equipmentList">-->
<!--              <td v-text="data.managementcode"></td>-->
<!--&lt;!&ndash;              <td v-text="data.equipmentcode"></td>&ndash;&gt;-->
<!--              <td v-text="data.archivename"></td>-->
<!--              <td v-text="data.typename"></td>-->
<!--              <td v-text="data.label"></td>-->
<!--            </tr>-->
<!--          </tbody>-->
<!--        </table>-->
      </van-collapse-item>
<!--      <van-collapse-item title="附件信息" name="3" v-show="inputForm.attachList.length > 0">-->
<!--        <a style="display: block;" v-for="file in inputForm.attachList" :href="file.url">{{file.name}}</a>-->
<!--      </van-collapse-item>-->
    </van-collapse>

    <process-record :procInsId="procInsId"></process-record>
  </div>
</template>
  
<script>
import EquipmentMaintenance from '@/api/equipment/EquipmentMaintenance.js'
import TaskService from '@/api/flowable/TaskService.js'
import ProcessService from '@/api/flowable/ProcessService'
import { ImagePreview } from 'vant';
import processRecord from "../../components/processRecord/processRecord";
export default {
  data() {
    return {
      dateinfo: '',
      activeNames: ['1', '2', '3'],
      isshow: false,
      radio: '',
      inputForm: {
        checkusername: '',
        scoreratio: '',
        standardName: '',
        frequency: '',
        levelname: '',
        id: '',
        projectId: '',
        projectName: '',
        customerId: '',
        customerName: '',
        houseId: '',
        houseName: '',
        feeItemNames: '',
        exchangeId: '',
        planMethod: '',
        dateOne: '',
        dateWeek: '',
        archiveMap: '',
        dateMonth: '',
        code: '',
        status: '',
        remarks: '',
        createDate: '',
        createByName: {
          id: ''
        },
        isDoTask: false,
        attachIds: [],
        attachList: [],
        reason: '',
        isLastTask: false,

      },
      auditForm: {
        message: '',
        type: '_flow_agree',
        status: '同意',
        userIds: null,
        assignee: null
      },
      taskId: '',
      taskDefKey: '',
      procInsId: '',
      procDefId: '',
      type:'',
      fields: [
        {key: 'managementCode', label: '管理编码'},
        {key: 'name', label: '设备名称'},
        {key: 'equipmentTypeIdName', label: '设备类型'},
        {key: 'enabledStatusName', label: '启用状态'},
        {key: 'runningStatusName', label: '运行状态'},
      ],
      items: [],
    }
  },
  components: {
    processRecord
  },
  mounted() {
  },

  created() {
    let query = this.$route.query;
    let id = query.id
    this.taskId = query.taskId
    this.taskDefKey = query.taskDefKey
    this.procInsId = query.procInsId
    this.procDefId = query.procDefId
    this.type = query.type || ''
    // let id = this.$cookie.get('id')
    // this.taskId = this.$cookie.get('taskId')
    // this.taskDefKey = this.$cookie.get('taskDefKey')
    // this.procInsId = this.$cookie.get('procInsId')
    // this.procDefId = this.$cookie.get('procDefId')
    this.init(id)

  },
  methods: {
    show() {
      this.isshow = !this.isshow
    },

    init(id) {
      new EquipmentMaintenance().queryEquipmentMaintenanceById(id).then(({ data }) => {

        this.inputForm = data

        this.items = data.equipmentList

      }).catch(e => {
        console.log(e)
      })
    },
    close() {
      if(this.type !== '') {
        this.$router.back()
      } else {
        //Android、iOS支持PC不支持
        dd.biz.navigation.close({
          onSuccess: function (result) {
          },
          onFail: function (err) {
          }
        })
        // //Android、iOS不支持，PC支持
        dd.biz.navigation.quit({
          message: "quit message",
          onSuccess: function (result) {
          },
          onFail: function () {
          }
        })
      }
    },
    timestampToTime(timestamp) {
      let date = new Date(timestamp);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + MM + "-" + d;// + " " + h + ":" + m + ":" + s;
    },
    submitTask() {
      if (this.auditForm.status == '同意') {
        this.agree()
      } else {
        this.reject()
      }
    },
    agree() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        let vars = {}
        vars = { ...vars, ..._this.inputForm }
        // _this.auditForm.message = _this.inputForm.remarks
        _this.auditForm.type = _this.inputForm.isLastTask?'_flow_approval':'_flow_agree'
        new TaskService().audit({
          taskId: _this.taskId,
          taskDefKey: _this.taskDefKey,
          procInsId: _this.procInsId,
          procDefId: _this.procDefId,
          vars: vars,
          comment: _this.auditForm,
          assignee: _this.auditForm.assignee
        }).then(({ data }) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          _this.inputForm.flowType = _this.inputForm.isLastTask ? 4 : 2;
          new EquipmentMaintenance().startFlow(_this.inputForm);

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    reject() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        new ProcessService().stop(_this.procInsId, _this.auditForm.message).then(({ data }) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
		  //更新数据库状态
		  _this.inputForm.flowType = 3;
		  new DeratedService().startFlow(_this.inputForm);
		  
          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    preview(url){
      ImagePreview([url])
    }
  }
}
</script>

<style>
.bgc-dark th {
  background-color: gainsboro !important;
  /*color: #FFFFFF!important;*/
  font-weight: bold;
}
</style>
  